import React, { Component } from "react";
import PropTypes from "prop-types";
import Logo from "../elements/Logo";

class AboutHeader extends Component {
    static propTypes = {
        headerImage: PropTypes.shape({
            thumb: PropTypes.string,
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    };

    render() {
        const { headerImage } = this.props;

        return (
            <div className="about-header">
                <div className="about-header__inner">
                    <div className="about-header__image-container">
                        {headerImage && (
                            <div
                                className="about-header__image"
                                style={{
                                    paddingTop: `${(headerImage.height /
                                        headerImage.width) *
                                        100}%`
                                }}
                            >
                                <picture>
                                    <source
                                        media="(max-width: 900px)"
                                        srcSet={headerImage.mobile}
                                    />
                                    <img
                                        src={headerImage.desktop}
                                        alt="Exit Films"
                                    />
                                </picture>
                            </div>
                        )}
                    </div>
                    <div className="about-header__logo">
                        <Logo />
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutHeader;



// WEBPACK FOOTER //
// ./src/scripts/components/AboutHeader.js